import React from "react";
import "./switch.scss";

interface SwitchProps {
    checked?: boolean;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

/**
 * Switch component for toggle functionality
 * @param {Object} props - Component props
 * @param {boolean} props.checked - Sets the checked state of the switch (default: false)
 * @param {Function} props.onChange - Function to change the checked state of the switch (default: () => {})
 * @returns {JSX.Element} Switch component
 */
const Switch: React.FC<SwitchProps> = ({ checked = false, onChange = () => {} }) => {
    return (
        <label className="toggle-switch">
            <input type="checkbox" checked={checked} onChange={onChange} />
            <span className="switch" />
        </label>
    );
};

export default Switch;
